export var OAuthPayloadMethods;
(function (OAuthPayloadMethods) {
    OAuthPayloadMethods["ParseRedirectResult"] = "magic_oauth_parse_redirect_result";
})(OAuthPayloadMethods || (OAuthPayloadMethods = {}));
export var OAuthErrorCode;
(function (OAuthErrorCode) {
    OAuthErrorCode["InvalidRequest"] = "invalid_request";
    OAuthErrorCode["InvalidClient"] = "invalid_client";
    OAuthErrorCode["InvalidScope"] = "invalid_scope";
    OAuthErrorCode["InvalidGrant"] = "invalid_grant";
    OAuthErrorCode["UnauthorizedClient"] = "unauthorized_client";
    OAuthErrorCode["UnsupportedResponseType"] = "unsupported_response_type";
    OAuthErrorCode["UnsupportedGrantType"] = "unsupported_grant_type";
    OAuthErrorCode["UnsupportedTokenType"] = "unsupported_token_type";
    OAuthErrorCode["AccessDenied"] = "access_denied";
    OAuthErrorCode["ServerError"] = "server_error";
    OAuthErrorCode["TemporarilyUnavailable"] = "temporarily_unavailable";
})(OAuthErrorCode || (OAuthErrorCode = {}));
//# sourceMappingURL=types.js.map